import { toast } from '@/stores/pure/ToastStore';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

export const STUDIO_ITEM_EXPORT_STORAGE_KEY = 'static-studio-item';

export type StudioItemPdfExportItem = {
  alias: Alias;
  title: string;
  created_at: RFCDateString;
  created_by: Alias;
  content: {
    body: string;
  };
};

export const exportStudioItemToPdf = (item: StudioItemPdfExportItem) => {
  localStorage.setItem(STUDIO_ITEM_EXPORT_STORAGE_KEY, JSON.stringify(item));

  const width = 1440;
  const height = 1024;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const windowFeatures = [
    'popup',
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'resizable=no',
    'scrollbars=no',
    'status=no',
    'menubar=no',
    'toolbar=no',
  ].join(',');

  const printWindow = window.open(
    `${window.location.origin}/workspace/${getCurrWorkspaceAlias()}/studio/${item.alias}/static`,
    `Export Report : ${item.title}`,
    windowFeatures,
  );

  if (!printWindow) {
    localStorage.removeItem(STUDIO_ITEM_EXPORT_STORAGE_KEY);
    toast('Popup is blocked. Please allow popups.', 'fail');
    return;
  }

  const cleanup = () => {
    localStorage.removeItem(STUDIO_ITEM_EXPORT_STORAGE_KEY);
  };

  const cleanupTimer = window.setInterval(() => {
    if (!printWindow.closed) return;
    cleanup();
    window.clearInterval(cleanupTimer);
  }, 500);

  printWindow.onload = () => {
    const checkRendering = () => {
      const targetElement =
        printWindow.document.querySelector<HTMLElement>('#static-root');

      if (!targetElement) {
        window.setTimeout(checkRendering, 100);
        return;
      }

      let previousHeight = 0;
      let stableCount = 0;
      const stableThreshold = 3;

      const waitForStableHeight = () => {
        const currentHeight = Math.max(
          printWindow.document.documentElement.scrollHeight,
          printWindow.document.body.scrollHeight,
          targetElement.scrollHeight,
        );

        if (currentHeight === previousHeight) {
          stableCount += 1;
        } else {
          stableCount = 0;
          previousHeight = currentHeight;
        }

        if (stableCount < stableThreshold) {
          window.setTimeout(waitForStableHeight, 200);
          return;
        }

        printWindow.onafterprint = () => {
          cleanup();
          window.clearInterval(cleanupTimer);
          printWindow.close();
        };

        window.setTimeout(() => {
          printWindow.print();
        }, 500);
      };

      waitForStableHeight();
    };

    checkRendering();
  };
};
